import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { UtilsService } from '../services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

    urlRest : any = environment;
    loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
      private http  : HttpClient,
      private utils : UtilsService,
      private router: Router
    ) { }

    // get isLoggedIn() {
    //   this.loggedIn.next(this.isLoggedUser());
    //   return this.loggedIn.asObservable();
    // }

    login(user: User) {
      if (user.nombre !== '' && user.password !== '' ) {
        const authData = {
          ...user,
          qbitsModulesId: this.urlRest.moduleId,
          returnSecureToken: true
        };
        return this.http.post(
          `${ this.urlRest.webLogin }`,
          authData
        ).pipe(
          map( resp => {
            if(resp){
              this.loggedIn.next(true);
              this.guardarToken( resp );
              //this.router.navigate(['home']);
              return resp;
            }
          })
        );
      }
    }

    private guardarToken( data: any ) {
      this.utils.setStorage('token', data.userWebLogin['token']);
      this.utils.setStorage('usuario', data);
        this.utils.setStorage('getOrg', true);
      let hoy = new Date();
      hoy.setSeconds( 3600 );
      this.utils.setStorage('expira', hoy.getTime().toString());
    }

    isLoggedUser(): boolean {
      let token = this.utils.getStorage('token')
      if(!token){ return false};
      const expira = Number(this.utils.getStorage('expira'));
      const expiraDate = new Date();
      expiraDate.setTime(expira);
      if ( expiraDate > new Date() ) {
        return true;
      } else {
        return false;
      }
    }

    logout() {
      this.utils.removeStorage();
      this.loggedIn.next(false);
      //this.router.navigate(['/login']);
      window.location.href = '/login';
    }

    isAccessUser(rol : []){
        let flag = false;
        try {
            let rolAccess = JSON.parse(this.utils.decryptUsingAES256());
            for(let r in rol){
                if(rol[r] == rolAccess['id']){
                    flag = true;
                    break;
                }
            }
            return flag;
        } catch (exception) {
            return flag;
        }

    }
}
